import React from 'react';
import {
  SideNav,
  NavItem,
  NavText,
} from '@app/modules/transaction-details/transactions-details-components';

type NavigationProps = {
  title: string;
  active?: boolean;
  onClick?: (e: any) => void;
  identifier: string;
};

type Props = {
  userInfo: any;
  setShowActivityLog?: any;
};

const TransactionNav = ({
  title,
  active,
  onClick,
  identifier,
}: NavigationProps) => {
  return (
    <NavItem>
      <NavText active={active} onClick={onClick} id={identifier}>
        {title}
      </NavText>
    </NavItem>
  );
};
type DetailSection = {
  id: string;
  title: string;
};
let sections: DetailSection[] = [
  { id: 'municipalityNav', title: 'Municipality Details' },
  { id: 'propertyNav', title: 'Property Information' },
  { id: 'documentsNav', title: 'Documents' },
  { id: 'involvedNav', title: 'Who is Involved?' },
  { id: 'checklistNav', title: 'Assignment Checklist' },
  { id: 'paymentNav', title: 'Payment Due' },
  { id: 'activityLogNav', title: 'Activity Log' },
];

export default function TransactionDetailSidenav({
  userInfo,
  setShowActivityLog,
}: Props) {
  const [activeSection, setActivrSection] = React.useState('municipalityNav');
  const onClick = (event: any) => {
    const sectionId = event.target.id;
    setActivrSection(sectionId);
    if (sectionId === 'activityLogNav') {
      setShowActivityLog(true);
    } else {
      setShowActivityLog(false);
    }
    const sectionContainerId = sectionId.replace('Nav', 'Details');
    const sectionElement = document.getElementById(sectionContainerId);
    if (sectionElement !== null) {
      sectionElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <SideNav>
        {sections.map((section: DetailSection, i: number) => (
          <TransactionNav
            title={section.title}
            key={i}
            active={activeSection === section.id}
            onClick={onClick}
            identifier={section.id}
          />
        ))}
      </SideNav>
    </>
  );
}
